import { render } from "./AnnualLeavePlanDetail.vue?vue&type=template&id=0b3632d8"
import script from "./AnnualLeavePlanDetail.vue?vue&type=script&lang=js"
export * from "./AnnualLeavePlanDetail.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\Cigl-Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__